/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetInstructions200ResponseData } from './GetInstructions200ResponseData'
import {
  GetInstructions200ResponseDataFromJSON,
  GetInstructions200ResponseDataFromJSONTyped,
  GetInstructions200ResponseDataToJSON,
} from './GetInstructions200ResponseData'

/**
 *
 * @export
 * @interface GetInstructions200Response
 */
export interface GetInstructions200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetInstructions200Response
   */
  status: boolean
  /**
   *
   * @type {GetInstructions200ResponseData}
   * @memberof GetInstructions200Response
   */
  data: GetInstructions200ResponseData
}

/**
 * Check if a given object implements the GetInstructions200Response interface.
 */
export function instanceOfGetInstructions200Response(
  value: object
): value is GetInstructions200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetInstructions200ResponseFromJSON(
  json: any
): GetInstructions200Response {
  return GetInstructions200ResponseFromJSONTyped(json, false)
}

export function GetInstructions200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetInstructions200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetInstructions200ResponseDataFromJSON(json['data']),
  }
}

export function GetInstructions200ResponseToJSON(
  value?: GetInstructions200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetInstructions200ResponseDataToJSON(value['data']),
  }
}
